module.exports = __webpack_public_path__ + "img/crunch.495bcd3a.svg";